interface BadgeProps {
  description?: string;
}
export const Badge: React.FC<BadgeProps> = ({ description }) => (
  <div className="bg-neutral-95 rounded-full py-4 px-5 inline-flex justify-start items-center h-[45px] ">
    {description}
  </div>
);
